import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as S from "../svg.style";
export var WarningBig = function(_param) /*#__PURE__*/ {
    var color = _param.color, secondColor = _param.secondColor, height = _param.height, width = _param.width, shrinkable = _param.shrinkable, rest = _object_without_properties(_param, [
        "color",
        "secondColor",
        "height",
        "width",
        "shrinkable"
    ]);
    return _jsxs(S.Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        height: height,
        width: width,
        viewBox: "0 0 64 64",
        shrinkable: shrinkable
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M26.161 11.471 7.495 46.044a6.667 6.667 0 0 0 5.853 9.907h37.333a6.667 6.667 0 0 0 5.854-9.853L37.868 11.524a6.667 6.667 0 0 0-11.707 0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                stroke: secondColor,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M32.015 21.285V40.07M32.348 46.618a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                stroke: secondColor,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M32.142 46.926a.333.333 0 1 0-.363-.072"
            })
        ]
    }));
};
